import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { Text, useLanguage } from '@xyz-school/xyz-react-frontend';

import Button from '@/ui/Button';
import { routes } from '@/Routes';

import AuthPageLayout from '@/pages/PageAuth/AuthPageLayout';
import thumb from '@/pages/PageAuth/images/phone-step-thumb.png';

const errorMessages: Record<string, string> = {
    provider_unavailable: 'Вход через этого провайдера сейчас недоступен.',
    provider_error: 'Провайдер вернул ошибку авторизации.',
    technical_error: 'Техническая ошибка. Попробуйте снова чуть позже.',
    invalid_callback: 'Некорректный ответ от провайдера.',
    invalid_next: 'Некорректный адрес возврата после авторизации.',
    invalid_state: 'Сессия входа устарела. Запустите вход заново.',
    provider_mismatch: 'Провайдер не совпадает с начатой авторизацией.',
};

const PageAuthError = () => {
    const { search } = useLocation();
    const { toLocalizedRoute } = useLanguage();

    const searchParams = useMemo(() => new URLSearchParams(search), [search]);
    const errorCode = searchParams.get('code') || 'technical_error';
    const provider = searchParams.get('provider');
    const message = errorMessages[errorCode] || errorMessages.technical_error;

    return (
        <AuthPageLayout
            image={thumb}
            title="Не удалось войти"
            description={message}
            info={
                provider ? (
                    <Text size="small" color="label" align="center">
                        Провайдер: {provider}
                    </Text>
                ) : undefined
            }
        >
            <Button styleType="default" size="large" isFullWidth linkTo={toLocalizedRoute(routes.AUTH)}>
                Вернуться на страницу входа
            </Button>
        </AuthPageLayout>
    );
};

export default PageAuthError;
